import React, { useState } from 'react';
import Header from '../header/enrollmentheader'; // Import the Header component
import insuranceImage from '../assert/insurance-covering.jpg'; // Adjust the path to your image
import '../css/enrollment.css'; // Import your CSS file for styling
import { MdNavigateNext } from "react-icons/md";
import { GoPaperAirplane } from "react-icons/go";
import CloseIcon from '@mui/icons-material/Close';


const Enrollment = () => {
    const [ageGroup, setAgeGroup] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [useName, setUserName] = useState('');
    const [phone, setPhone] = useState('');
    const [currentStep, setCurrentStep] = useState(1); // Initialize with the first step
    const [showError, setShowError] = useState(false);
    const [showContinue, setShowContinue] = useState(false);
    const [showAge, setShowAge] = useState(true);
    const [showZipCode, setShowZipCode] = useState(false);
    const [showPhone, setShowPhone] = useState(false);
    const [showUseName, setShowUseName] = useState(false);
    const [date, setDate] = useState('');
    const [showPopup, setPopup] = useState(true);
    const [showStep, setShowStep] = useState(true);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const handleAgeChange = (event) => {
        setAgeGroup(event.target.value);
        setShowContinue(true);
    };

    const handleDateChange = (event) => {
        const selectedDate = new Date(event.target.value);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const minDate = new Date(1900, 0, 1);
        setDate(event.target.value);

        if (selectedDate < currentDate && selectedDate >= minDate) {
            setShowContinue(true);
            console.log("value in Correct format ", selectedDate + " " + currentDate);
            setShowError(false);
        } else {
            setShowContinue(false);
            setShowError(true);
        }
    };

    const handleNameChange = (event) => {
        setUserName(event.target.value);

        if (event.target.value !== null && event.target.value !== '') {
            setShowContinue(true);
        } else {
            setShowContinue(false);
        }
    };

    const phoneValidation = (event) => {
        const phone = event.target.value.replace(/[^0-9]/g, '');
        setPhone(phone);
        if (phone.length === 10) {
            setShowError(false);
            setShowContinue(true);
        } else {
            setShowContinue(false);
            setShowError(true);
        }
    }

    const zipCodeVerification = (event) => {
        const zip = event.target.value;
        const zipCodePattern = /^\d{5}(-\d{4})?$/; // Pattern for 5 digits or ZIP+4
        if (zip.length < 11) {
            console.log("Zip length Check 10 > ", zip.length);
            if (zip === '' || zipCodePattern.test(zip)) {
                console.log("Zipcode in Correct Format")
                setShowContinue(true)
                setShowError(false);
            } else {
                console.log("zipcode not in correct format");
                setShowContinue(false)
                setShowError(true);
            }
        }
    };

    const zipCodeFormat = (event) => {
        const zip = event.target.value.replace(/[^0-9]/g, '');
        let zipCorrectedValue = ''
        let zip5 = zip.substring(0, 5);
        let zipAfter5 = zip.substring(5, 9);
        if (zip.length < 10) {
            if (zip.length <= 5) {
                zipCorrectedValue = zip5;
                setZipCode(zipCorrectedValue);
            } else {
                zipCorrectedValue = zip5 + '-' + zipAfter5;
                setZipCode(zipCorrectedValue);
            }
        }
    }

    const handleContinue = () => {
        if (date !== null && date !== '' && zipCode === '') {
            setShowAge(false);
            setShowZipCode(true);
            setShowContinue(false);
        } else if (date !== null && date !== '' && zipCode !== null && zipCode !== '' && useName === '') {
            setShowZipCode(false);
            setShowUseName(true);
            setShowContinue(false);
        } else if (date !== null && date !== '' && zipCode !== null && zipCode !== '' && useName !== '' && useName !== null) {
            setShowUseName(false);
            setShowPhone(true);
            setShowContinue(false);
        } else if (date !== null && date !== '' && zipCode !== null && zipCode !== '' && useName !== '' && useName !== null && phone !== null && phone !== '') {
            setShowPhone(false);
            setShowContinue(false);
            setShowStep(false);
            setShowSuccessMessage(true);
        }
        setCurrentStep((prevStep) => prevStep + 1); // Move to the next step
        console.log("Button Clicked");
    };

    const openPopup = (e) => {
        e.preventDefault(); // Prevents the default link behavior
        setPopup(true)
    }

    const closePopup = (e) => {
        e.preventDefault(); // Prevents the default link behavior
        setPopup(false)
    }

    const calculateAge = (dob) => {
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();

        // Adjust age if the birthday hasn't occurred yet this year
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };

    const fetchLocation = () => {
        return fetch(`https://ziptasticapi.com/${zipCode}`, {
            headers: {
                'Accept': 'application/json',
            },
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                // Pass the state to fetchStates function
                fetchStates(data.state);  // Assuming 'state' is a field in the response
            })
            .catch(err => {
                console.error('Error fetching location:', err);
            });
    };


    const fetchStates = (stateAbbr) => {
        return fetch('https://rms.healtheesystems.com:9443/Script/stateInUS.json', {
            headers: {
                'Accept': 'application/json',
            },
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                // Find the matching state from the data
                const matchedState = data.find(state => state.abbreviation === stateAbbr);


                console.log('Matched State:', matchedState);
                fetchserviceID(matchedState.name); // Return the matched state
            })
            .catch(err => {
                console.error('Error fetching states:', err);
            });
    };

    const fetchserviceID = (stateName) => {
        console.log("Get Service ID Entered");

        return fetch(`https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/get-services?service=Hot`, {
            headers: {
                'Accept': 'application/json',
            },
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                // Filter services based on the provided stateName
                const filteredServices = data.filter(service =>
                    service.serviceName.toLowerCase().includes(stateName.toLowerCase())
                );

                // If no services found for the provided stateName, check for generic services
                if (filteredServices.length === 0) {
                    const genericServices = data.filter(service =>
                        service.serviceName.toLowerCase().includes("generic")
                    );

                    // If generic services are found, pass only the first serviceId
                    if (genericServices.length > 0) {
                        console.log("Generic Services Found: ", genericServices);
                        captureCustomer(genericServices[0].serviceId, stateName); // Pass only the first serviceId
                    } else {
                        console.log("No matching services or generic services found.");
                    }
                } else {
                    // Extract the first serviceId from filtered services
                    const serviceDetails = {
                        serviceName: filteredServices[0].serviceName,
                        serviceId: filteredServices[0].serviceId
                    };

                    console.log("Filtered Service: ", serviceDetails);
                    captureCustomer(serviceDetails.serviceId, stateName); // Pass only the first serviceId
                }
            })
            .catch(err => {
                console.error('Error fetching services:', err);
            });
    };


    const captureCustomer = (ServiceID, state) => {
        const url = 'https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/capture-customer';
        console.log("Service ID: " + ServiceID);

        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so we add 1
        const day = String(now.getDate()).padStart(2, '0'); // Add leading zero if needed
        const hours = String(now.getHours()).padStart(2, '0'); // Add leading zero if needed
        const minutes = String(now.getMinutes()).padStart(2, '0'); // Add leading zero if needed
        const seconds = String(now.getSeconds()).padStart(2, '0'); // Add leading zero if needed

        setShowPhone(false);
        setShowContinue(false);
        setShowStep(false);
        setShowSuccessMessage(true);

        const data = {
            username: useName,
            phoneNumber: '1' + phone,
            rdate: `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`,
            code: zipCode,
            dob: date,
            serviceId: ServiceID,
            age: calculateAge(date),
            loadId: 100,
            state: state
        };
        
        console.log(data);

        // Use Promise syntax instead of async/await
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                return response.json(); // Return the JSON from the response
            })
            .then(result => {
                console.log('Success:', result);
            })
            .catch(error => {
                console.error('Error:', error);
            });
    };

    return (
        <div>
            <div style={{ position: 'relative' }}>
                <img src={insuranceImage} alt="Insurance covering" className="enrollment-image" />
                <div className="image-overlay" />
            </div>

            {showPopup && (
                <div className="overlay">
                    <div className="header-container">
                        {/* <h2 className="container-header">Insurance</h2> */}
                        {/* <CloseIcon className="close-popup" onClick={closePopup} /> */}
                    </div>
                    <p className="paragraph">Start your journey to coverage today!</p>
                    <hr className="divider" />

                    <div className="step-count">
                        {showStep && <p>Step {currentStep} of 4</p>}
                    </div>

                    {showAge && (
                        <div className="dob-selection">
                            <p className="dob-Header">Date of Birth</p>
                            <div className="dob-container">
                                <input
                                    type="date"
                                    id="dob"
                                    className="dob-input"
                                    value={date}
                                    onChange={handleDateChange}
                                    max={new Date().toISOString().split("T")[0]} // Ensures the user cannot select a future date
                                />
                                {showContinue && <MdNavigateNext className="dateSend-icon" onClick={handleContinue} />}
                            </div>
                            <p className={`error-Message ${showError ? 'show' : ''}`}>Select the Correct Date</p>
                        </div>
                    )}

                    {showZipCode && (
                        <div className="dob-selection">
                            <div className="zip-code-container">
                                <p className='zipCode-Header'>ZIP code</p>
                                <div className="input-icon-container">
                                    <input
                                        type="text"
                                        id="zipCode"
                                        className="zip-code-input"
                                        placeholder="Enter ZIP code"
                                        maxLength={11}
                                        value={zipCode}
                                        onChange={(e) => {
                                            zipCodeFormat(e);
                                            zipCodeVerification(e);
                                        }}
                                    />
                                    {showContinue && <MdNavigateNext className="send-icon" onClick={handleContinue} />}
                                </div>
                                <p className={`error-Message ${showError ? 'show' : ''}`}>Zipcode Not in the correct format</p>
                            </div>
                        </div>
                    )}

                    {showUseName && (
                        <div className="dob-selection">
                            <div className="user-name-container">
                                <p className='name-Header'>Name</p>
                                <div className="input-icon-container">
                                    <input
                                        type="text"
                                        id="userName"
                                        className="user-name-input"
                                        placeholder="Enter Name"
                                        value={useName}
                                        onChange={handleNameChange}
                                    />
                                    {showContinue && <MdNavigateNext className="send-icon" onClick={handleContinue} />}
                                </div>
                                <p className={`error-Message ${showError ? 'show' : ''}`}>Zipcode Not in the correct format</p>
                            </div>
                        </div>

                    )}

                    {showPhone && (
                        <div className="dob-selection">
                            <div className="phone-container">
                                <p className="phone-Header">Mobile Number</p>
                                <div className="input-icon-container">
                                    <input
                                        type="text"
                                        id="phone"
                                        className="phone-input"
                                        placeholder="Phone Number"
                                        value={phone}
                                        maxLength={10}
                                        onChange={phoneValidation}
                                    />
                                    {showContinue && <GoPaperAirplane className="submit-icon" onClick={fetchLocation} />}
                                </div>
                                <p className={`error-Message ${showError ? 'show' : ''}`}>Mobile Number Not in the correct format</p>
                            </div>
                        </div>
                    )}

                    {showSuccessMessage && (
                        <div className="Success-container">
                            <p className="SuccessMessage-Header">Thank you for reaching out to us. We will call you soon. Have a good day!</p>
                        </div>
                    )}
                </div>
            )}

        </div>
    );
};

export default Enrollment;
